import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskServiceModalNewRoute: InvariantJiraRoute = {
	name: 'servicedesk-service-modal-new',
	path: '/jira/servicedesk/service-modal',
	exact: true,
};
